import { accessRole } from "../../../helpers/access_role";
import ErrorAccess from "../../../components/Error/Content/Access";

import IndexView from "./Index/View";
import UploadView from "./Upload/View";
import DetailView from "./Detail/View";

const RouteView = (props) => {
  const queryParams = new URLSearchParams(props.location.search);
  const _detail = queryParams.get("detail");
  const _upload = queryParams.get("upload");

  const _uuid = queryParams.get("uuid");

  if (_detail != null) {
    return accessRole("read") ? <DetailView /> : <ErrorAccess />;
  } else if (_upload != null) {
    return accessRole("read") ? <UploadView /> : <ErrorAccess />;
  }
  return accessRole("read") ? <IndexView /> : <ErrorAccess />;
};
export default RouteView;
